import { render, staticRenderFns } from "./information.vue?vue&type=template&id=04a35748&"
import script from "./information.vue?vue&type=script&lang=js&"
export * from "./information.vue?vue&type=script&lang=js&"
import style0 from "./information.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./information.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "information.vue"
export default component.exports